import { Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Home from "./views/Home";
import Login from "./views/Login";
import TrainerPortal from "./trainerPortal/TrainerPortal";

import { SideBarContextProvider } from "./context/SideBarContext";
import "./style/App.css";

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  palette: {
    primary: {
      main: "#ff5722",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SideBarContextProvider>
        <Routes>
          {/* Primary: Affiliator portal */}
          <Route path="/affiliatorportal/*" element={<TrainerPortal />} />
          {/* Legacy aliases (trainerportal, trainer-portal) kept for backward compatibility */}
          <Route path="/trainerportal/*" element={<TrainerPortal />} />
          <Route path="/trainer-portal/*" element={<TrainerPortal />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </SideBarContextProvider>
    </ThemeProvider>
  );
}

export default App;
